import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { cssProperty } from '@holmescorp/middleware/css-property';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { convertToBoolean } from '@holmescorp/common';

import css from '../css/progress-viz.m.css';

export interface ProgressVizProperties {
	title: string;
	percent: number;
	xqa: string;
	indent?: boolean;
}

const nls = createNlsMiddleware('ditabook');
const factory = create({ nls, theme, cssProperty }).properties<ProgressVizProperties>();

const lang = window.hcstatic.portal_language || 'en';
const num = new Intl.NumberFormat('en', { style: 'decimal', maximumSignificantDigits: 2 });
const pct = new Intl.NumberFormat(lang, { style: 'percent', maximumSignificantDigits: 2 });

export const ProgressViz = factory(({ properties, middleware: { nls, theme, cssProperty } }) => {
	const {
		messages: {
			assess_progress_threshold_low = '60',
			assess_progress_threshold_high = '80',
			assess_progress_show_percent = 'true'
		}
	} = nls();
	const { xqa, title, percent, indent = false } = properties();
	const score = percent * 100;
	const scorePercent = cssProperty.get('root', '--score-percent');
	if (scorePercent !== num.format(percent)) {
		cssProperty.set('root', '--score-percent', num.format(percent));
	}
	const barScore = pct.format(parseFloat(percent.toFixed(2)));
	const showPercent = convertToBoolean(assess_progress_show_percent);

	const chooseBarStyle = () => {
		if (score == 0) {
			return themeCss.barZero;
		}
		if (score < parseFloat(assess_progress_threshold_low)) {
			return themeCss.barLow;
		}

		if (score < parseFloat(assess_progress_threshold_high)) {
			return themeCss.barMid;
		}

		return themeCss.barHigh;
	};

	const themeCss = theme.classes(css);
	return v(
		'div',
		{ key: 'root', role: 'listitem', xqa, classes: [indent ? themeCss.scoreContainer : themeCss.root] },
		[
			v('div', { key: 'title', classes: [themeCss.title] }, [title]),
			v('div', { key: 'wrapper', classes: [themeCss.wrapper] }, [
				v('div', { key: 'field', classes: [themeCss.field] }, [
					v('div', { key: 'bar', classes: [themeCss.bar, chooseBarStyle()] })
				]),
				v(
					'div',
					{
						key: 'bar-score',
						xqa: 'viz score',
						classes: [themeCss.barscore]
					},
					showPercent ? [`${barScore}`] : []
				)
			])
		]
	);
});
